import { Box } from '@mui/material'
import { type PlanOrganization } from '../../../../models/PlanOrganization'
import { PriorityCard } from './PriorityCard'
import { generatePath } from 'react-router'
import { AppRoutes } from '../../../Routes'
import { useNavigate, useParams } from 'react-router-dom'
import { AnnualPlanTabs } from '../PlanningDetails'

interface Props {
  planOrganization: PlanOrganization
  implementationPhase?: boolean
}

export const PriorityActivityOverview = (props: Props): JSX.Element => {
  const nav = useNavigate()
  const { rcnId, planId, planOrgId } = useParams()

  const handleSelectedPriority = (planOrganizationTaskId: number): void => {
    if (rcnId == null || planId == null || planOrgId == null) {
      return
    }

    const route = generatePath(
      props.implementationPhase === true
        ? AppRoutes.IMPLEMENTATION_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY
        : AppRoutes.PLANNING_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY,
      {
        rcnId,
        planId,
        tab: String(AnnualPlanTabs.PriorityActivities),
        planOrgId,
        planOrgTaskId: String(planOrganizationTaskId)
      }
    )
    nav(route)
  }

  return (
    <Box
      data-testid='activitiesOverview'
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '33px'
      }}
    >
      {props.planOrganization.priorities.map((p) =>
        <PriorityCard
          key={p.priorityNumber}
          handlePriorityContinue={() => { handleSelectedPriority(p.planOrganizationTaskId) }}
          num={p.priorityNumber}
          title={p.compellingWhy}
          activities={p.activities}
        />)}
    </Box>
  )
}
